// extracted by mini-css-extract-plugin
export default {"productList":"ProviderProductList_productList__a1bkG","metadata":"ProviderProductList_metadata__VQ-g3","pagination":"ProviderProductList_pagination__7i3Jo"};